import { createContext } from "react";

export const ReportParamsContext = createContext([{}, () => {}]);
